import { clsx } from 'clsx';

import IwocaPayIcon from '../../../components/svg/IwocaPayIcon.svg?react';
import type { WhiteLabelTheme } from '../../store/WhiteLabelProvider';

type Ratio = NonNullable<WhiteLabelTheme['preferred_logo_type']>;

export const WhiteLabelLandingLogo = ({
  url,
  ratio,
  themeColor,
}: {
  url: string;
  ratio: Ratio;
  themeColor: string | null;
}) => {
  return (
    <div
      className={clsx(
        `m-xl mb-0 h-5xl border-b pb-xl [@media(max-width:600px)]:m-l [@media(max-width:600px)]:mb-0 [@media(max-width:600px)]:pb-l`,
        ratio === 'square' && 'h-[calc(theme(spacing.xl)+80px)]', // Had to do some math to set height equal to padding and desired logo height
        ratio === 'rectangle' && 'h-5xl [@media(max-width:600px)]:h-4xl',
      )}
      style={{ borderColor: `${themeColor}33` }} // tailwind doesn't like dynamic variables
    >
      <img className="h-full object-contain" src={url} alt="Brand Logo" />
    </div>
  );
};

type WhiteLabelPayLinkLogoProps = React.HTMLAttributes<HTMLDivElement> & {
  url: string;
  ratio: Ratio;
  themeColor: string | null;
};

export const WhiteLabelPayLinkLogo = ({
  url,
  ratio,
  themeColor,
  className,
  ...props
}: WhiteLabelPayLinkLogoProps) => {
  return (
    <div
      {...props}
      className={clsx(
        `m-xl mb-l ml-0 border-b pb-xl`,
        ratio === 'square' && 'h-[calc(theme(spacing.xl)+80px)]', // Had to do some math to set height equal to padding and desired logo height
        ratio === 'rectangle' && 'h-5xl',
        className,
      )}
      style={{ borderColor: `${themeColor}33` }} // tailwind doesn't like dynamic variables
    >
      <img className="h-full object-contain" src={url} alt="Brand Logo" />
    </div>
  );
};

export const WhiteLabelHeaderLogo = ({
  url,
  ratio,
}: {
  url: string;
  ratio: Ratio;
}) => {
  return (
    <div
      className={clsx(
        `-mb-m ml-0 mt-l pl-s [@media(max-width:800px)]:mb-0`,
        ratio === 'square' && 'h-3xl',
        ratio === 'rectangle' && 'h-xl',
      )}
    >
      <img className="h-full object-contain" src={url} alt="Brand Logo" />
    </div>
  );
};

export const PoweredByIwocaPay = () => {
  return (
    <p className="mt-s flex items-center text-s">
      Powered by&nbsp;
      <IwocaPayIcon className="mt-xs w-[7rem] fill-core-65" />
    </p>
  );
};
